import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { parseShortDateWithTime, formatHours, durationBetweenDates } from '../../../../utils/dates';

export default function AssignmentDetails({ assignment }) {
  return (
    <React.Fragment>
      <div className="clinician-info-box">
        <Typography variant="h6" gutterBottom>
          Assignment details
        </Typography>
        <List className="list-underline">
          <ListItem>
            <ListItemText primary="Activities" />
            <span className="divider" />
            <ListItemText secondary={assignment.primaryLabel} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Postcode" />
            <span className="divider" />
            <ListItemText secondary={assignment.postcode || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="RAG status" />
            <span className="divider" />
            <ListItemText secondary={assignment.ragStatus.name} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Description" />
            <span className="divider" />
            <ListItemText secondary={assignment.description || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Planned Travel Time" />
            <span className="divider" />
            <ListItemText
              secondary={`${durationBetweenDates(
                new Date(assignment.startDate),
                new Date(assignment.visitStartDate),
              )}min`}
            />
          </ListItem>
          <ListItem>
            <ListItemText primary="Planned Start Date" />
            <span className="divider" />
            <ListItemText secondary={parseShortDateWithTime(assignment.visitStartDate)} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Planned End Date" />
            <span className="divider" />
            <ListItemText secondary={parseShortDateWithTime(assignment.endDate)} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Actual Start Date" />
            <span className="divider" />
            <ListItemText secondary={parseShortDateWithTime(assignment.visitStarted)} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Actual End Date" />
            <span className="divider" />
            <ListItemText secondary={parseShortDateWithTime(assignment.visitEnded)} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Duration" />
            <span className="divider" />
            <ListItemText secondary={formatHours(assignment.duration)} />
          </ListItem>
        </List>
      </div>
    </React.Fragment>
  );
}
